module.exports = "<span class=\"mat-h5\">No results</span>\n<span class=\"mat-body1\">Sorry! There are no OTPs.</span>"